import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { CaskSubType } from "@/app/services/generated/casktypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { caskTypeService } from "@/app/services/generated/casktypeService";

// Singleton cache store
const caskSubTypesCacheStore = new EntityCacheStore<CaskSubType>(
  EnumCacheEntityType.caskSubType,
  async () => caskTypeService.getAllCaskSubTypes()
);

// Ephemeral reader
export default class CaskSubTypesCache extends EntityWithGuidKeyCache<CaskSubType> {
  constructor() {
    super(caskSubTypesCacheStore, (x) => x.id);
  }
}
